import(/* webpackMode: "eager" */ "/vercel/path0/src/app/simulate/setup/page.tsx");
